export default __webpack_public_path__ + "static/media/hall_layout.082cfd0a.jpg";